<template>
  <div class="h-screen font-sans login bg-cover">
    <div
      class="container mx-auto flex justify-center items-center min-h-screen relative"
    >
      <!-- 居中组件 -->
      <div class="mx-6 sm:max-w-lg w-full relative">
        <!-- 公告通知 -->
        <div
          class="absolute top-[-150px] w-full flex justify-center z-10"
          v-if="
            userInfo.noticeData.state ? userInfo.noticeData.state == 1 : false
          "
        >
          <div class="sm:max-w-lg w-full px-6">
            <el-alert
              :title="'网站公告:'"
              type="warning"
              class="custom-alert-title"
            >
              <Vue3Marquee
                :pauseOnHover="true"
                :duration="15"
                :delay="2"
                :clone="true"
                class="text-base"
              >
                {{ userInfo.noticeData.desc }}
              </Vue3Marquee>
            </el-alert>
          </div>
        </div>

        <div
          class="w-full rounded-3xl px-20 py-4 bg-gray-100 shadow-md"
          style="min-height: 30rem"
        >
          <label
            for=""
            class="block mt-16 text-title text-gray-700 text-center font-semibold"
          >
            《资源下载》<span class="text-red-500"
              >剩余下载次数: {{ userData.useNum }}次</span
            >
            <span class="text-red-500 ml-6"
              >到期时间: {{ userData.end_time }}</span
            >
          </label>
          <div class="mt-14">
            <div class="relative flex">
              <div
                class="flex justify-center items-center mr-2 font-normal w-20 whitespace-nowrap"
              >
                资料链接:
              </div>
              <input
                v-model="userInfo.link"
                :placeholder="userInfo.placeholderPhone"
                class="mt-1 pl-4 pr-4 block w-full bg-gray-100 h-11 rounded-xl shadow-lg focus:border focus:outline-none focus:border-blue-400"
                autofocus
              />
            </div>

            <div class="flex mt-12 pl-8 pr-8 mb-10 pt-2">
              <button
                class="flex bg-blue-500 justify-center font-normal w-full py-3 rounded-xl text-white shadow-xl hover:shadow-inner focus:outline-none transition duration-500 ease-in-out transform hover:-translate-x hover:scale-105"
                @click="onSubmit"
              >
                <div>点击解析文件</div>
              </button>
            </div>

            <div class="flex mt-7 pl-8 pr-8 items-center text-center">
              <hr class="border-gray-300 border-1 w-full rounded-md" />
              <label class="block font-medium text-sm text-gray-400 w-full">
                查询提取记录 / 购买套餐
              </label>
              <hr class="border-gray-300 border-1 w-full rounded-md" />
            </div>
            <div class="flex mt-4 mb-4 justify-center w-full">
              <div
                class="flex justify-center items-center bg-green-600 border-none px-4 py-2 rounded-xl cursor-pointer text-white shadow-xl hover:shadow-inner transition duration-500 ease-in-out transform hover:-translate-x hover:scale-105"
                @click="record"
              >
                <span class="ml-1 text-sm">提取记录</span>
              </div>
              <button
                v-if="dataInfo.is_pay == '1'"
                class="whitespace-nowrap bg-red-500 text-sm rounded-xl ml-6 text-white shadow-xl hover:shadow-inner focus:outline-none transition duration-500 ease-in-out transform hover:-translate-x hover:scale-105 ml-2 p-3"
                @click="toImgPay"
              >
                在线购买套餐
              </button>
            </div>
          </div>

          <div v-if="tableVisible">
            <div class="pl-8 pr-8 mt-14 mb-14">
              <el-table :data="userInfo.allTableData" style="width: 100%">
                <el-table-column label="资料名称" width="600">
                  <template #default="scope">
                    <el-popover
                      effect="light"
                      trigger="hover"
                      placement="top"
                      width="auto"
                    >
                      <template #default>
                        <div>资料名称: {{ scope.row.title }}</div>
                      </template>
                      <template #reference>
                        <span class="text-ellipsis" style="">{{
                          scope.row.title
                        }}</span>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="本站消耗次数" width="120">
                  <template #default="">
                    <el-popover
                      effect="light"
                      trigger="hover"
                      placement="top"
                      width="auto"
                    >
                      <template #reference>
                        <el-tag>1次</el-tag>
                      </template>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column label="官方价格">
                  <template #default="scope">
                    <div style="display: flex; align-items: center">
                      <span>{{ scope.row.price }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作下载" width="100">
                  <template #default="scope">
                    <el-button
                      size="small"
                      :type="isDownloaded(scope.row) ? 'success' : 'danger'"
                      :class="
                        isDownloaded(scope.row) ? 'bg-green-400' : 'bg-red-400'
                      "
                      @click="handleDelete(scope.row)"
                    >
                      {{ isDownloaded(scope.row) ? "已 下 载" : "点击下载" }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      v-if="dataInfo.is_pay == '1'"
      data-v-9ea40744=""
      :src="userInfo.payImg"
      alt="请登录后操作"
      class="login-tip-image"
      @click="toImgPay"
    />

    <el-dialog
      v-model="centerDialogVisible"
      title="解析成功"
      :width="dialogWidth"
      align-center
    >
      <div class="mb-6 text-red-500 text-responsive">
        <span>《 解析成功 》 请点击《 立即下载 》按钮进行下载 </span>
      </div>
      <div class="mb-6">
        <span class="text-responsive1"
          ><span class="text-blue-500">如果点击</span
          >下载按钮下载失败(或者出现403)
          <!-- <span class="text-xl text-red-500">下载失败(或者出现403)</span> -->
          按照下面方法操作:
        </span>
      </div>
      <!-- <span class="text-xl"
      >点击复制链接按钮,打开<span class="text-red-500">(新的标签页)</span
      >粘贴到地址栏进行下载
    </span> -->
      <span class="text-responsive1"
        >点击复制链接按钮,打开(新的标签页)粘贴到地址栏进行下载
      </span>
      <!-- <div class="mt-6">
      <span>（一定要打开浏览器新的标签页） </span>
    </div> -->
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="handCopy" class="text-responsive1"
            >复制下载链接手动下载</el-button
          >
          <!-- <el-button type="primary" class="bg-blue-400" @click="handDownload">
          点击下载
        </el-button> -->

          <!-- 不带请求来源 -->
          <a
            class="btn btn-danger text-responsive1"
            :href="userInfo.downloadPath"
            target="_blank"
            rel="noreferrer noopener nofollow"
            >立即下载</a
          >
        </span>
      </template>
    </el-dialog>

    <el-dialog
      v-model="zujuanVisible"
      title="请根据需求选择下载选项(提交后不可更改)"
      :width="dialogWidth"
      align-center
    >
      <div class="mb-6 text-base text-black">
        答案位置：
        <el-select
          v-model="userInfo.paperTypevalue"
          placeholder="请选择"
          style="width: 100%; font-size: 1rem"
          class="mt-2"
          @change="handleAnswerPositionChange"
        >
          <el-option
            v-for="item in userInfo.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div v-if="userInfo.showDownloadParse" class="mb-6 text-base text-black">
        下载解析：
        <el-select
          v-model="userInfo.downParsevalue"
          placeholder="请选择"
          class="mt-2"
          style="width: 100%; font-size: 1rem"
        >
          <el-option
            v-for="item in userInfo.downParseoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <!-- <el-button type="primary" class="bg-blue-400" @click="handDownload">
          点击下载
        </el-button> -->

          <!-- 不带请求来源 -->
          <a @click="onSubmitZuJuan" class="btn btn-danger text-responsive1"
            >解析试卷</a
          >
        </span>
      </template>
    </el-dialog>

    <!-- 点击 购买套餐详情 弹窗 -->
    <el-row class="margin-bottom:300px;">
      <el-dialog
        v-model="payPopUpVisible"
        width="50%"
        align-center
        style="padding-bottom: 40px"
      >
        <div class="mb-6 text-xl text-red-500 pr-10 pl-10">
          <span
            >当前选择套餐《{{ dataInfo.selectPackageName }}》-
            付款后套餐自动到账，刷新页面即可查看
          </span>
        </div>
        <!-- Rest of your existing code remains the same -->
        <div class="mt-16" v-show="dataInfo.showQrCode">



          <div class="flex flex-col items-center">
            <p>
              请使用
              <span class="text-red-500 text-xl">{{ dataInfo.payText }}</span>
              扫码付款
            </p>
            <p class="mt-3">付款以后套餐自动到账(刷新页面即可查看)</p>

            <!-- 支付宝官方支付容器 -->
           
          <!-- iframe 支付容器 -->
          <div v-if="dataInfo.isIframe=='1'" class="pay-box">
            <iframe
              :src="dataInfo.qRCode"
              frameborder="0"
              scrolling="no"
              class="pay-iframe"
            ></iframe>
          </div>

          <div v-else><img class="w-80 mt-4" :src="dataInfo.qrCodeDataUrl" /></div>
          </div>
        </div> </el-dialog
    ></el-row>

    <!-- 自选套餐弹窗 -->
    <el-row class="margin-bottom:300px;">
      <el-dialog
        v-model="payCenterDialogVisible"
        width="60%"
        align-center
        style="padding-bottom: 40px"
      >
        <div class="mb-6 text-xl text-red-500 pr-10 pl-10">
          <span> 注意: 请认真选择套餐,购买成功以后无法更换 </span>
        </div>
        <div class="flex flex-wrap pr-10 pl-10 pt-6">
          <div class="w-full mb-6">
            <div class="flex flex-wrap">
              <div v-for="item in dataInfo.siteInfo" :key="item.id">
                <div
                  class="fl_box_leng flex flex-col justify-center mt-4"
                  :class="{ fl_box_leng_xz: dataInfo.showState == item.id }"
                  @click="selectPackage(item.id, item.description, item.name)"
                >
                  <div>{{ item.name }}</div>
                  <div class="fl_box_xz"><span>￥</span>{{ item.price }}</div>
                  <img
                    src="@/assets/ccccc.png"
                    class="absolute -bottom-5 -right-2"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ml-10 mt-8">
          <div class="">请选择付款方式:</div>
          <el-radio-group v-model="radio1" class="mt-4">
            <el-radio
              label="alipay"
              size="large"
              border
              v-if="dataInfo.payType == '0' || dataInfo.payType == '2'"
              ><img src="../assets/alipay.jpg" class="w-14" alt=""
            /></el-radio>
            <el-radio
              label="wxpay"
              size="large"
              border
              v-if="dataInfo.payType == '1' || dataInfo.payType == '2'"
              ><img src="../assets/wxpay.png" class="h-6" alt=""
            /></el-radio>
          </el-radio-group>
          <button
            class="mt-6 ml-8 bg-blue-500 w-28 py-2 rounded-xl text-white shadow-xl hover:shadow-inner focus:outline-none transition duration-500 ease-in-out transform hover:-translate-x hover:scale-105"
            @click="handlePay"
          >
            购买套餐
          </button>
        </div>
      </el-dialog></el-row
    >
  </div>
  <input ref="textCopy" value="" style="opacity: 0; position: absolute" />
</template>
<script>
// import { useMessage } from "@/src/utils/useMessage.js";
import { useRouter, useRoute } from "vue-router";
import { http, http2, http3 } from "@/utils/http";
import { fp, reportPp, resetReportState } from "@/utils/jquery";

import {
  onMounted,
  reactive,
  ref,
  onUnmounted,
  inject,
  onBeforeUnmount,
  computed,
  watch,
} from "vue";
import { useMessage } from "@/utils/useMessage.js";
import QRCode from "qrcode";

export default {
  setup() {
    const router = useRouter();
    const route = useRoute();
    const centerDialogVisible = ref(false);
    const payCenterDialogVisible = ref(false);
    const zujuanVisible = ref(false);
    const tableVisible = ref(false);
    const payPopUpVisible = ref(false);
    const dialogWidth = ref("80%");
    const radio1 = ref("alipay");

    const userInfo = reactive({
      allTableData: [],
      downloadPath: "",
      noticeData: {},
      link: "",
      code: "",
      placeholderPhone: "请输入材料的网址",
      placeholderCode: "请先点击下方提取账号按钮",
      downParse: "",
      paperType: "",
      payUrl: "",
      payImg: "",
      options: [
        {
          label: "卷尾-答案显示在试卷末尾",
          value: "normal",
        },
        {
          label: "题后-答案显示在每题后面",
          value: "teacher",
        },
        {
          label: "无答案-试卷不包含答案",
          value: "student",
        },
      ],
      downParseoptions: [
        {
          label: "附带解析-包含详细解题过程",
          value: "true",
        },
        {
          label: "不带解析-仅包含题目和答案",
          value: "false",
        },
      ],
      paperTypevalue: "normal",
      downParsevalue: "true",
      showDownloadParse: true, // 控制显示/隐藏 "下载解析"
    });

    const selectedSitesInfo = reactive({
      selectedSites: [],
      selectedSiteNames: [],
    }); // 确保这是一个数组

    const dataInfo = reactive({
      siteInfo: null,
      selectPackageName: "",
      showState: 0,
      packageId: 0,
      showQrCode: false,
      description: "",
      payType: "0",
      qrCodeDataUrl: "",
      is_pay: "0",
      qRCode:"",
      isIframe:""
    });

    const intervalId = ref(null);
    const visibilityHandler = ref(null);


    

    const handlePay = async () => {
      try {
        // 确定支付方式
        if (radio1.value === "alipay") {
          dataInfo.payText = "支付宝";
        } else if (radio1.value === "wxpay") {
          dataInfo.payText = "微信";
        } else {
          useMessage("error", "请选择支付方式");
          return;
        }
        if (dataInfo.packageId == 0) {
          useMessage("error", "请选择需要购买的套餐");
          return;
        }
        // 步骤1：提交订单请求
        const response = await http.post(
          "/v1/user/createOrder?auth=" + authParam,
          {
            packageId: dataInfo.packageId,
            payType: radio1.value,
          }
        );
        const res = response.data;
        if (res.code !== 200) {
          useMessage("error", res.message);
          return;
        }
        useMessage("success", res.message);
        dataInfo.showPayType = false;
        dataInfo.showQrCode = true;

        // window.open(res.data.qRCode, "_blank", "noopener,noreferrer")

        payCenterDialogVisible.value = false;

        dataInfo.qRCode = res.data.qRCode
        dataInfo.isIframe = res.data.isIframe

        // 生成二维码图片
        const qrCodeDataUrl = await QRCode.toDataURL(res.data.qRCode);
        dataInfo.qrCodeDataUrl = qrCodeDataUrl;
        payPopUpVisible.value = true;

        const orderNo = res.data.order_no;

        let attempts = 0;
        const maxAttempts = 50;

        // 步骤2：定时检查支付状态
        intervalId.value = setInterval(async () => {
          if (attempts >= maxAttempts) {
            clearInterval(intervalId.value);
            useMessage("error", "支付状态检查超时。");
            return;
          }
          attempts++;
          try {
            const paymentStatusResponse = await http3.post(
              "/v1/user/checkOrder?auth=" + authParam,
              {
                order_no: orderNo,
              },
              {
                headers: {
                  userToken: localStorage.getItem("userToken"),
                },
              }
            );
            if (paymentStatusResponse.data.code === 200) {
              clearInterval(intervalId.value);
              useMessage("success", "支付成功！正在刷新页面...");
              // 支付成功直接刷新页面信息
              location.reload();
            }
          } catch (error) {
            console.error("检查支付状态时出错:", error);
            // 可以选择在多次失败后停止检查
            if (attempts >= maxAttempts) {
              clearInterval(intervalId.value);
              useMessage("error", "支付状态检查失败，请手动确认支付状态。");
            }
          }
        }, 2000);

        // 监听页面可见性变化
        visibilityHandler.value = () => {
          if (document.visibilityState === "hidden") {
            clearInterval(intervalId.value);
          }
        };
        document.addEventListener("visibilitychange", visibilityHandler.value);
      } catch (error) {
        console.error("发生错误:", error);
        确保在出错时也清理定时器和监听器;
        if (intervalId) clearInterval(intervalId);
        if (handleVisibilityChange) {
          document.removeEventListener(
            "visibilitychange",
            handleVisibilityChange
          );
        }
        useMessage("error", "支付流程出现异常，请重试或联系客服。");
      }
    };

    // userInfo.link ="https://www.zxxk.com/docpack/3372398.html"
    // 在线支付获取套餐
    const toImgPay = () => {
      http
        .get("/v1/user/getAllPackage?auth=" + authParam, {})
        .then((response) => {
          const res = response.data;
          if (res.code !== 200) {
            useMessage("error", res.message);
            return;
          }
          dataInfo.siteInfo = res.data.packageData;
          dataInfo.payType = res.data.payType;
          payCenterDialogVisible.value = true;
          // 默认选择第一个套餐
          if (res.data.payType == "1") {
            radio1.value = "wxpay";
          }
          useMessage("success", res.message);
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
      // window.open(userInfo.payUrl, "_blank", "noopener,noreferrer");
    };
    // const btnPay = () => {
    //   window.open(userInfo.payUrl, "_blank", "noopener,noreferrer");
    // };

    const record = () => {
      router.push("/record?auth=" + authParam);
    };
    let textCopy = ref();
    //    =========================================================
    const userData = reactive({
      useNum: 0,
      end_time: "",
    });

    // 获取 URL 参数
    const authParam = route.query.auth;

    // 获取用户信息
    const getUserNum = () => {
      http
        .get("/v1/user/getUserNum?auth=" + authParam, {})
        .then((res) => {
          if (res.data.code != 200) {
            useMessage("error", res.data.message);
            return;
          }
          userData.useNum = res.data.data.userData.num;
          userData.end_time = res.data.data.userData.end_time;
          userInfo.noticeData = res.data.data.noticeData;
          userInfo.payUrl = res.data.data.payUrl;
          userInfo.payImg = res.data.data.payImg;
          dataInfo.is_pay = res.data.data.is_pay;
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    };
    // 页面加载
    onMounted(() => {
      getUserNum();
      // ============= 获取Jquery js =============
      resetReportState();
      reportPp(authParam);
      fp(authParam);
    });

    const updateDialogWidth = () => {
      const screenWidth = window.innerWidth;
      if (screenWidth < 600) {
        dialogWidth.value = "70%";
      } else if (screenWidth >= 600 && screenWidth <= 800) {
        dialogWidth.value = "50%";
      } else if (screenWidth > 800 && screenWidth <= 1200) {
        dialogWidth.value = "40%";
      } else {
        dialogWidth.value = "23%";
      }
      // dialogWidth.value = screenWidth < 600 ? '70%' : '23%';
    };

    // 获取套餐
    const selectPackage = (index, description, selectPackageName) => {
      dataInfo.showState = index;
      dataInfo.packageId = index;
      dataInfo.showQrCode = false;
      dataInfo.description = description;
      dataInfo.selectPackageName = selectPackageName;
    };

    const handleAnswerPositionChange = (value) => {
      // 当选择 "无答案-试卷不包含答案" 时隐藏 "下载解析"
      if (value === "student") {
        userInfo.showDownloadParse = false;
      } else {
        userInfo.showDownloadParse = true;
      }
    };

    onMounted(() => {
      updateDialogWidth();
      window.addEventListener("resize", updateDialogWidth);
    });

    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateDialogWidth);
    });

    // 提取账号
    const onSubmit = () => {
      tableVisible.value = false;
      if (
        (userInfo.link.indexOf("keyword") !== -1 ||
          userInfo.link.indexOf("xkw.com") !== -1) &&
        userInfo.link.indexOf("zhijiao.xkw.com") == -1
      ) {
        zujuanVisible.value = true;
        return;
      }
      try {
        http2
          .post("/v1/user/parse?auth=" + authParam, {
            link: userInfo.link,
          })
          .then((res) => {
            // 出错
            if (res.data.code !== 200) {
              useMessage("error", res.data.message);
              return;
            }
            if (res.data.data.down_type === "1") {
              useMessage("success", res.data.message);
              userInfo.downloadPath = res.data.data.down_url;
              centerDialogVisible.value = true;
              getUserNum();
            } else {
              tableVisible.value = true;
              userInfo.allTableData = res.data.data.catalog_list;
            }
          })
          .catch((error) => {
            console.error("发生错误:", error);
            // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
          });
      } catch (error) {
        console.error("请求失败", error);
      }
    };

    // 组卷网解析
    const onSubmitZuJuan = () => {
      tableVisible.value = false;
      try {
        http2
          .post("/v1/user/parse?auth=" + authParam, {
            link: userInfo.link,
            downParse: userInfo.downParsevalue,
            paperType: userInfo.paperTypevalue,
          })
          .then((res) => {
            // 出错
            if (res.data.code !== 200) {
              useMessage("error", res.data.message);
              return;
            }
            zujuanVisible.value = false;
            if (res.data.data.down_type === "1") {
              useMessage("success", res.data.message);
              userInfo.downloadPath = res.data.data.down_url;
              centerDialogVisible.value = true;
              getUserNum();
            } else {
              tableVisible.value = true;
              userInfo.allTableData = res.data.data.catalog_list;
            }
          })
          .catch((error) => {
            console.error("发生错误:", error);
            // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
          });
      } catch (error) {
        console.error("请求失败", error);
      }
    };

    const downloadedItems = ref(new Set()); // 用于存储已下载项目的集合

    const isDownloaded = (row) => {
      return downloadedItems.value.has(row.href);
    };

    const handleDelete = (linkStr) => {
      try {
        http2
          .post("/v1/user/parse?auth=" + authParam, {
            link: linkStr.href,
          })
          .then((res) => {
            // 出错
            if (res.data.code !== 200) {
              useMessage("error", res.data.message);
              return;
            }
            if (res.data.data.down_type === "1") {
              useMessage("success", res.data.message);
              userInfo.downloadPath = res.data.data.down_url;
              centerDialogVisible.value = true;
              downloadedItems.value.add(linkStr.href); // 下载成功后标记为已下载
            }
            getUserNum();
          })
          .catch((error) => {
            console.error("发生错误:", error);
            // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
          });
      } catch (error) {
        console.error("请求失败", error);
      }
    };

    // 点击复制文本
    const handCopy = () => {
      const text = userInfo.downloadPath; // 复制文本内容
      const input = textCopy.value;
      input.value = text; // 修改input的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 浏览器复制
      useMessage(
        "success",
        "链接复制成功,请在浏览器新标签页地址栏粘贴复制的链接进行手动下载"
      );
    };

    return {
      // btnPay,
      toImgPay,
      handCopy,
      userInfo,
      centerDialogVisible,
      zujuanVisible,
      onSubmit,
      record,
      //////////   =========================================================
      userData,
      textCopy,
      handleDelete,
      tableVisible,
      // handleDownload,
      isDownloaded,
      downloadedItems,
      dialogWidth,
      handleAnswerPositionChange,
      onSubmitZuJuan,
      payCenterDialogVisible,
      dataInfo,
      selectedSitesInfo,
      selectPackage,
      radio1,
      handlePay,
      payPopUpVisible,
    };
  },
};
</script>

<style lang="scss" scoped>
.login {
  background: url("@/assets/background.webp") center / cover no-repeat fixed;
}

/* 图片样式 */
// .login-tip-image {
//   display: block;
//   max-width: 100%;
//   height: auto;
//   margin: 0 auto;
//   position: relative;
//   z-index: 2;
//   filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.15));
//   animation: imageFloat 3s ease-in-out infinite;
// }
.login-tip-image {
  position: fixed;
  width: 376px;
  padding: 0;
  height: auto;
  overflow: hidden;
  border-radius: 16px;
  background: #fff;
  cursor: pointer;
  top: 60px;
  right: 40px;
  z-index: 2;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.15));
  animation: imageFloat 3s ease-in-out infinite;

  /* 添加缩放自适应 */
  transform-origin: top right; /* 缩放基点设置为右上角 */
  transition: all 0.3s ease; /* 添加平滑过渡 */
}


.pay-box {
  width: 700px;
  height: 500px;
}

.pay-iframe {
  width: 1200px;
  height: 900px;

  transform: scale(0.6);
  transform-origin: left top;

  border: 0;
}

@keyframes imageFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg) scale(var(--scale-factor, 1));
  }
  33% {
    transform: translateY(-8px) rotate(-1.5deg) scale(var(--scale-factor, 1));
  }
  66% {
    transform: translateY(6px) rotate(1.5deg) scale(var(--scale-factor, 1));
  }
}

/* 页面缩放时的自适应样式 */
@media screen and (max-width: 1920px) {
  .login-tip-image {
    --scale-factor: 0.9;
    width: 338px; /* 376 * 0.9 */
    top: 54px; /* 60 * 0.9 */
    right: 36px; /* 40 * 0.9 */
  }
}

@media screen and (max-width: 1600px) {
  .login-tip-image {
    --scale-factor: 0.8;
    width: 301px; /* 376 * 0.8 */
    top: 48px; /* 60 * 0.8 */
    right: 32px; /* 40 * 0.8 */
  }
}

@media screen and (max-width: 1440px) {
  .login-tip-image {
    --scale-factor: 0.7;
    width: 263px; /* 376 * 0.7 */
    top: 42px; /* 60 * 0.7 */
    right: 28px; /* 40 * 0.7 */
  }
}

@media screen and (max-width: 1280px) {
  .login-tip-image {
    --scale-factor: 0.6;
    width: 226px; /* 376 * 0.6 */
    top: 36px; /* 60 * 0.6 */
    right: 24px; /* 40 * 0.6 */
  }
}

/* 页面太小时的隐藏条件 */
@media screen and (max-width: 1024px) {
  .login-tip-image {
    display: none !important; /* 在较小屏幕上完全隐藏 */
  }
}

/* 高度限制 - 如果页面高度太小也隐藏 */
@media screen and (max-height: 600px) {
  .login-tip-image {
    display: none !important;
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px) {
  .login-tip-image {
    display: none !important; /* 在移动端完全隐藏 */
  }
}

/* 打印时隐藏 */
@media print {
  .login-tip-image {
    display: none !important;
  }
}
// ======================
.custom-alert-title ::v-deep .el-alert__title.is-bold {
  font-size: 16px !important; /* 强制应用 */
}

.el-alert {
  border-radius: 14px; /* 强制应用 */
}

.sm\:max-w-lg {
  max-width: 80rem;
  // min-height:150renm;
}

.toUp {
  margin-top: -40px;
  transition: all 0.5s;
}

.list {
  list-style: none;
  text-align: center;
  overflow: hidden;
  height: 40px;
  padding: 0;
  margin: 0;
}
li {
  text-align: left;
  height: 40px;
  line-height: 40px;
}
.btn-danger {
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}
.btn-danger:hover {
  background-color: #c82333 !important; /* 鼠标悬停时的背景色 */
  border-color: #bd2130 !important; /* 鼠标悬停时的边框颜色 */
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.dialog-footer button:first-child {
  margin-right: 10px;
}

.text-ellipsis {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
}

.bg-green-400 {
  background-color: #38a169 !important;
  color: white !important;
}
.bg-red-400 {
  background-color: #e53e3e !important;
  color: white !important;
}

@media (max-width: 600px) {
  .text-responsive {
    font-size: 0.85rem;
  }
}

@media (min-width: 601px) {
  .text-responsive {
    font-size: 1.2rem;
  }
}

@media (max-width: 600px) {
  .text-responsive1 {
    font-size: 0.6rem;
  }
}

@media (min-width: 601px) {
  .text-responsive1 {
    font-size: 0.9rem;
  }
}

@media (max-width: 600px) {
  .text-title {
    font-size: 1rem;
  }
}

@media (min-width: 601px) {
  .text-title {
    font-size: 1.25rem;
  }
}
[v-cloak] {
  display: none; /* v-cloak 指令的元素在 Vue 编译之前保持隐藏 */
}
.fl_box_leng {
  overflow: hidden;
  min-width: 153px;
  background: #f8f8f8;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  margin-right: 14px;
  height: 67px;
  padding-right: 20px;
  padding-left: 19px;
  font-size: 16px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  margin-bottom: 10px;
}

.fl_box_leng_zixuan {
  overflow: hidden;
  min-width: 153px;
  background: #f8f8f8;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  margin-right: 14px;
  height: 67px;
  padding-right: 20px;
  padding-left: 19px;
  font-size: 16px;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  position: relative;
  margin-bottom: 10px;
}

.fl_box_xz {
  opacity: 0.76;
  color: #505050;
  font-size: 14px;
  margin-top: 6px;
}
.fl_box_x_zixuan {
  opacity: 0.76;
  color: #505050;
  font-size: 14px;
}
.fl_box_leng_xz {
  color: #fff;
  background: linear-gradient(-45deg, #3369ff, #3798f7);
  -webkit-box-shadow: 0 7px 10px 0 rgb(54 144 248 / 23%);
  box-shadow: 0 7px 10px 0 rgb(54 144 248 / 23%);
  border: 1px solid #3580fb;
  .fl_box_xz {
    color: #ebebeb;
  }
}

.tag-container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px; /* 设置标签之间的空隙，可以根据需要调整 */
}

.tag-item {
  /* 其他可能的样式 */
}
</style>
